<template>
  <v-dialog v-model="active" width="480" persistent>
    <v-card color="primary" class="ui-module-card ui-module-fade-in-up">
      <v-card-title class="font-weight-bold justify-center ui-module-titlebar">Eliminar asignación</v-card-title>
      <v-card-text class="text-center pt-4">
        ¿Confirmas que deseas eliminar esta asignación de equipo? Los equipos incluidos volverán a estar disponibles.
      </v-card-text>
      <v-card-actions class="justify-center pb-4 ui-module-actions">
        <v-btn text class="ui-module-btn-text-danger mx-8" @click="closeDialog()">Cancelar</v-btn>
        <v-btn
          color="secondary"
          class="ui-module-btn-solid mx-8"
          :loading="loading"
          :disabled="loading"
          @click="confirmarEliminacion()"
          >Eliminar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    asignacion: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      loading: false,
    }
  },

  methods: {
    ...mapActions('subsedeAsignacion', ['updateAsignacionEquipo']),

    closeDialog() {
      this.loading = false
      this.$emit('close')
    },

    async confirmarEliminacion() {
      if (!this.asignacion) return

      this.loading = true
      try {
        const equipoAsignado = (this.asignacion.equipoAsignado || []).map((equipo) => ({
          id: equipo.id,
          fk_idEquipo: equipo.fk_idEquipo,
          estatus: false,
        }))

        await this.updateAsignacionEquipo({
          idSubSede: this.asignacion.idSubSede,
          idDetalleAsignacion: this.asignacion.idDetalleAsignacion,
          payload: {
            fechaSolicitud: this.asignacion.fechaSolicitud,
            fechaAsignacion: this.asignacion.fechaAsignacion,
            observaciones: this.asignacion.observaciones,
            folioResguardo: this.asignacion.folioResguardo,
            equipoAsignado,
            adjunto: null,
          },
        })

        this.closeDialog()
      } catch {
        // error ya manejado en el store (snackbar)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
